import getEnv from '../env/enviroment';

declare global {
  interface Window {
    // hold segments analytics
    analytics: any;
    prevPath: string | null;
  }
}
window.analytics = window.analytics || {};

export default class Analytics {
  static env = getEnv();
  static init() {
    if (this.env.segment_api_key) {
      window.analytics._writeKey = this.env.segment_api_key;
      window.analytics.load(this.env.segment_api_key);
      this.trackCurrentPage(window.location.pathname);
    }
  }

  static trackCurrentPage(pathname: string) {
    if (this.env.segment_api_key && pathname !== window.prevPath) {
      window.prevPath = pathname;
      window.analytics.page();
    }
  }

  static trackEvent(eventName: string, payload: any) {
    if (this.env.segment_api_key) {
      window.analytics.track(eventName, payload);
    }
  }
}
